import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './../styles/styles.css';

export default function Confirmation() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(''); // État pour stocker le statut de paiement

  useEffect(() => {
    // Récupérer le statut de la redirection de Stripe
    const redirectStatus = searchParams.get('redirect_status');
    if (redirectStatus === 'succeeded') {
      setStatus('success');
    } else {
      setStatus('failed');
    }
  }, [searchParams]);

  return (
    <div>
      {status === 'success' ? (
        <section className="section-black confirmation-header">
          <h1>Paiement réussi !</h1>
          <p>Merci pour votre achat. Votre enquête est prête à être jouée.</p>
        </section>
      ) : (
        <section className="section-black confirmation-header">
          <h1>Paiement échoué</h1>
          <p>Une erreur est survenue lors de la transaction. Veuillez réessayer ou contacter le support.</p>
        </section>
      )}

      <section className="section-cream confirmation-content">
        {status === 'success' ? (
          <div className="confirmation-details">
            <h2>Votre commande</h2>
            <p>
              Votre jeu est maintenant disponible dans votre tableau de bord.
            </p>
            <Link to="/dashboard" className="cta-button">Accéder à mon enquête</Link>
          </div>
        ) : (
          <div className="confirmation-details">
            <p>
              Votre paiement n'a pas pu être finalisé. Veuillez vérifier vos informations de paiement et réessayer.
            </p>
            <Link to="/checkout" className="cta-button">Réessayer le paiement</Link>
          </div>
        )}
      </section>
    </div>
  );
}